export default "__VITE_ASSET__4OlzlJRb__"